export default __webpack_public_path__ + "static/mobile-app-hero-e623bb582e4c934064da890072c50264.webp";